import { compose } from 'recompose'
import Tabs from './Tabs'

export default compose()(Tabs)
